import { useOnboardingPackagesMap } from "./hooks/useOnboardingPackagesMap";
import { usePromotedPackage } from "./hooks/usePromotedPackage";

const PromotedPackage = () => {
	const promotedPackage = usePromotedPackage();
	const map = useOnboardingPackagesMap();

	if (!promotedPackage) return null;

	return map[promotedPackage.packageId];
};

export default PromotedPackage;
